module.exports = __webpack_public_path__ + "img/IMAGE007.f3de2503.jpeg";